export default __webpack_public_path__ + "static/media/x-button-2.fd1b3900.png";